<template>
  <div class="report-page">
    <layout-header :isFixedHeader="false"></layout-header>

    <div class="container" v-if="isReady">
      <section v-if="$Util.isEmpty(electData)">
        <h1 class="title">전력비 절감 컨설팅 정보가 등록되지 않았습니다.</h1>
        <p class="description">컨설팅 현황은 담당자에게 문의해 주세요.</p>
      </section>
      <section v-else-if="electData.serviceStatus === 99">
        <h1 class="title">전력비 절감<br>컨설팅 진행 현황</h1>
        <article>
          <progress-time-line v-bind:electData="electData"></progress-time-line>
        </article>
      </section>
      <section v-if="$Util.isEmpty(assetList)">
        <h1 class="title">전력비 절감 보고서 정보가 등록되지 않았습니다.</h1>
        <p class="description">보고서 등록 현황은 담당자에게 문의해 주세요.</p>
      </section>
      <section v-else>
        <article>
          <h1 class="title">
            <div class="month" ref="month" style="margin-top: 2rem;">
              <button type="button" @click="prev"><img src="@/assets/img/i_left.svg" alt=""></button>
              <div>{{ `${assetData.assetYear}년 ${assetData.assetMonth}월` }}</div>
              <button type="button" @click="next"><img src="@/assets/img/i_right.svg" alt=""></button>
            </div>
          </h1>
          <compare ref="compare"
                   :beforeTotalBill="electData.electType === 1 ? assetData.beforeTotalBill : assetData.afterTotalBill1 + assetData.savePrice"
                   :afterTotalBill="assetData.afterTotalBill1 + assetData.afterTotalBill2"
                   :savingAmount="assetData.savePrice"
                   :savingAmountRate="assetData.savePriceRate">
          </compare>

          <div class="divider"></div>

          <div class="total-wrap">
            <h1 class="title">종합 보고서</h1>
            <div class="table-wrap">
              <table class="table total-table">
                <thead>
                <tr>
                  <th>구분</th>
                  <th>년월</th>
                  <th>사용기간</th>
                  <th>컨설팅 전</th>
                  <th>컨설팅 후</th>
                  <th>절감금액</th>
                  <th>절감율</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(asset, index) in assetList" :key="index" @mouseover="mouseOverTotalTable(asset)"
                    @mouseout="totalBarChartFocusIndex = null">
                  <td>{{ pageInfo.virtualNum - index }}</td>
                  <td>{{ `${asset.assetYear}년 ${asset.assetMonth}월` }}</td>
                  <td>{{ `${asset.startUseDate1} ~ ${asset.endUseDate1}` }}</td>
                  <td>{{
                      electData.electType === 1 ? $Util.formatNumber(asset.beforeTotalBill) : $Util.formatNumber(asset.afterTotalBill1 + asset.savePrice)
                    }}원
                  </td>
                  <td>{{ $Util.formatNumber(asset.afterTotalBill1 + asset.afterTotalBill2) }}원</td>
                  <td>{{ $Util.formatNumber(asset.savePrice) }}원</td>
                  <td>{{ $Util.formatNumber(asset.savePriceRate) }}%</td>
                  <td>
                    <a href="#" @click.prevent="detailPage(asset)" class="aLink">자세히</a>
                  </td>
                </tr>
                <tr>
                  <th colspan="3">합계</th>
                  <th style="text-align: left;">{{ $Util.formatNumber(sumBeforeTotalBill) }}원</th>
                  <th style="text-align: left;">{{ $Util.formatNumber(sumAfterTotalBill) }}원</th>
                  <th style="text-align: left;">{{ $Util.formatNumber(sumSavePrice) }}원</th>
                  <th style="text-align: left;">{{ $Util.formatNumber(avgSavePriceRate) }}%</th>
                  <th></th>
                </tr>
                </tbody>
              </table>
              <base-pagination class="pagination-no-border"
                               v-model="pageInfo.page"
                               v-on:change="getAssetReportData"
                               v-bind:pageInfo="pageInfo"
                               v-if="pageInfo.totalPage > 1"
                               style="width: 100%; margin-top: 0.5rem;">
              </base-pagination>
            </div>

            <div class="divider"></div>

            <div class="chart-wrap">
              <h1 class="title">종합 보고서 차트</h1>
              <report-total-bar-chart :assetList="assetList"
                                      :height="200"
                                      :focusIndex="totalBarChartFocusIndex"
                                      class="report-total-bar"
                                      ref="reportTotalBar">
              </report-total-bar-chart>
              <report-bar-chart v-bind:assetData="reportAssetData"
                                :height="200"
                                class="report-bar-chart"
                                ref="reportBarChart">
              </report-bar-chart>
            </div>
          </div>
        </article>
      </section>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>
<script>
import ReportTotalBarChart from '@/components/chart/reportTotalBarChart'
import ReportBarChart from '@/components/chart/reportBarChart'
import ReportDonutChart from '@/components/chart/reportDonutChart'
import ProgressTimeLine from '@/components/pages/ProgressTimeLine'
import Compare from '@/components/pages/Compare'
import BasePagination from '@/components/pages/BasePagination'


export default {
  components: {
    ReportDonutChart,
    ReportBarChart,
    ReportTotalBarChart,
    ProgressTimeLine,
    Compare,
    BasePagination
  },
  data: function () {
    return {
      electData: {},
      beforeAsset: {
        labels: ['기본요금', '전력량 요금', '전력 기금', '역률 요금'],
      },
      afterAsset: {
        labels: ['기본요금', '전력량 요금', '전력 기금', '역률 요금'],
      },
      pageInfo: {
        page: 1,
        limit: 12
      },
      assetList: [],
      assetData: {},
      reportAssetData: {},
      assetIndex: 0,
      customerType: 1,
      isReady: false,
      assetMonth: '',
      totalBarChartFocusIndex: null,
      numberBeforeTotalBill: 0,
      numberAfterTotalBill: 0,
      duration: 1,
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    },
    sumBeforeTotalBill: function () {
      return this.assetList.map(asset => {
        if (this.electData.electType === 1) {
          return asset.beforeTotalBill
        } else {
          return asset.afterTotalBill1 + asset.savePrice
        }
      })
      .reduce((result, current) => result + current, 0)
    },
    sumAfterTotalBill: function () {
      return this.assetList.map(asset => {
        return asset.afterTotalBill1 + asset.afterTotalBill2
      })
      .reduce((result, current) => result + current, 0)
    },
    sumSavePrice: function () {
      return this.assetList.map(asset => asset.savePrice)
      .reduce((result, current) => result + current, 0)
    },
    avgSavePriceRate: function () {
      return (this.assetList.map(asset => asset.savePriceRate)
      .reduce((result, current) => result + current, 0) / this.assetList.length).toFixed(2)
    }
  },
  created: async function () {
    await this.getServiceData()
    await this.getAssetReportData(1)
  },
  mounted: function () {
    const _this = this
    let isFirst = true
    setTimeout(() => {
      _this.$refs.compare.start()
    }, 300)


    // setTimeout(() => {
    //   window.addEventListener('scroll', () => {
    //     if (isFirst) {
    //       if (_this.$refs.month.getBoundingClientRect().top - window.innerHeight < -120) {
    //         _this.$refs.compare.start()
    //         isFirst = false
    //       }
    //
    //     }
    //   })
    // }, 20)
  },
  methods: {
    mouseOverTotalTable: function (asset) {
      this.reportAssetData = asset
    },
    getServiceData: async function () {
      const params = {userNo: this.userData.userNo}
      const res = await this.$MainSvc.getServiceStatus(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        if (!this.$Util.isEmpty(entity.electData)) {
          this.electData = entity.electData
        }
      }
    },
    getAssetReportData: async function (page = 1) {
      let params = {userNo: this.userData.userNo};
      params.page = page
      params.limit = 12

      const res = await this.$AssetSvc.getAssetReportData(params)
      const code = res.code
      const message = res.message
      const entity = res.entity


      if (code === 1) {
        this.assetList = entity.list
        this.assetData = entity.list[this.assetIndex]
        this.reportAssetData = entity.list[this.assetIndex]
        this.pageInfo = entity.pageInfo
        this.isReady = true

        setTimeout(() => {
          this.$refs.reportTotalBar.rerender()
        }, 1)
      }
    },
    prev: function () {
      if (this.assetIndex >= this.assetList.length - 1) {
        return
      }
      this.assetIndex += 1
      this.assetData = this.assetList[this.assetIndex]
      this.classifyAsset()

      this.$refs.compare.start()
    },
    next: function () {
      if (this.assetIndex <= 0) {
        return
      }
      this.assetIndex -= 1;
      this.assetData = this.assetList[this.assetIndex]
      this.classifyAsset()

      this.assetMonth = this.assetData.assetMonth

      this.$refs.compare.start()
    },
    detailPage: function (asset) {
      // 고압인 경우 그대로
      if (this.electData.electType === 1) {
        this.$router.push({
          path: '/elect/reportDetail',
          query: {
            assetNo: asset.assetNo,
            assetYear: asset.assetYear,
            assetMonth: asset.assetMonth
          }
        })
      }
      // 저압인 경우 새로운 상세 페이지로
      else {
        this.$router.push({
          path: '/elect/reportDetailLow',
          query: {
            assetNo: asset.assetNo,
            assetYear: asset.assetYear,
            assetMonth: asset.assetMonth
          }
        })
      }
    },
  }
}
</script>
